module.exports = __webpack_public_path__ + "img/1544676745.b766b794.jpg";